import React, { useState, useEffect } from "react";
import {
  Button,
  message,
  Steps,
  Form,
  Input,
  Select,
  Row,
  Col,
  Upload,
  Result,
  Spin,
} from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { ONBDocDetails, ONBDetils } from "../../Redux/actions/OnboardAction";
import { useHistory } from "react-router-dom";
import { ONBProfileEdit } from "./EditProfDetails";
import {
  PlusOutlined,
  FilePdfOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { TrainingQuestion } from "./TrainingQuestion";
// import { startCountdown, updateTime } from "../../Redux/actions/TrainingTime";

const { Step } = Steps;
const { Dragger } = Upload;
const OnboardStep = ({ setSelectedContent }) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const travelnum = useSelector((state) => state.traveldetail.travelnum);
  const travelDetail = useSelector((state) => state.traveldetail);
  const OTPData = useSelector((state) => state?.posp?.onbDocs);
  // const { startTime, initialRemainingTime, remainingTime } = useSelector(
  //   (state) => state?.timer
  // );
  const [AadharfileList, setAadharfileList] = useState([]);
  const [PanfileList, setPanfileList] = useState([]);
  const [EdufileList, setEdufileList] = useState([]);
  const [PassfileList, setPassfileList] = useState([]);
  const [loading, setloading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [current, setCurrent] = useState(0);
  const [KycCheck, setKycCheck] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  // const [time, setTime] = useState(15 * 60 * 60);
  const [showCount, setShowCount] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const [formattedTime, setFormattedTime] = useState("");
  // const [QuestionData, setQuestionData] = useState([]);
  const [showNext, setShowNext] = useState(false);
  const [Status, setStatus] = useState("");
  const [KycInfo, setKycInfo] = useState("");
  const [profData, setProfData] = useState("");

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_DOC_URL_LIVE;
    setBaseURL(BASEURL);
    fetchData();
    onViewDocTime();
  }, [KycCheck, Status]);

  const onViewDocTime = () => {
    setShowCount(true);
    axiosInPosp
      .get(`v1/posp/examination/questions`)
      .then((res) => {
        console.log("examination/questions", res);
        if (res?.status === 200) {
          setShowCount(false);
          setShowNext(true);
          // const QData = res?.data;
          // setQuestionData(QData);
        }
      })
      .catch((err) => {
        // console.log(err.response.headers);
        const { data } = err.response;
        console.log("data", data?.message);
        const match = data?.message.match(/\d+/);
        if (match) {
          const seconds = parseInt(match[0], 10);
          console.log(seconds);
          setRemainingTime(seconds);
        }
      });
  };
  const onDocClick = () => {
    axiosInPosp
      .get(`v1/posp/examination/training_materials`)
      .then((res) => {
        // console.log(res?.headers);
        const { status } = res;
        console.log(status);
        if (status === 200) {
          setShowCount(true);
          const { link } = res?.data;
          console.log("PdfData", link);
          window.open(link, "_blank");
          axiosInPosp
            .get(`v1/posp/examination/questions`)
            .then((res) => {
              console.log("examination/questions", res);
              if (res?.status === 200) {
                setShowCount(false);
                setShowNext(true);
                // const QData = res?.data;
                // setQuestionData(QData);
              }
            })
            .catch((err) => {
              // console.log(err.response.headers);
              const { data } = err.response;
              console.log("data", data?.message);
              const match = data?.message.match(/\d+/);
              if (match) {
                const seconds = parseInt(match[0], 10);
                console.log(seconds);
                setRemainingTime(seconds);
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // dispatch(startCountdown());
  };
  useEffect(() => {
    // Function to format time in "hh:mm:ss"
    const formatTime = (seconds) => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${hours}h ${minutes}m ${secs}s`;
    };
    // console.log("remainingTime", remainingTime);
    // Update the formatted time initially and whenever remainingTime changes
    setFormattedTime(formatTime(remainingTime));

    // Return if remainingTime is 0 or less
    if (remainingTime <= 0) return;

    // Set an interval to decrease remaining time every second
    const intervalId = setInterval(() => {
      setRemainingTime((prev) => prev - 1);
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [remainingTime]);

  const fetchData = () => {
    setloading(true);
    axiosInPosp
      .get(`v1/posp/profile/edit`)
      .then((res) => {
        console.log("v1/posp/profile/edit", res);
        const ProfData = res?.data?.profile;
        console.log(ProfData);
        setProfData(ProfData);
        // form.setFieldsValue({
        //   aadhaar_number: ProfData?.aadhaar_number,
        // });
        if (ProfData?.kyc_status?.id) {
          if (ProfData.kyc_status.id >= 5) {
            setStatus("TRAINING_COMPLETED");
            setCurrent(3);
            setKycCheck(true);
          } else if (ProfData.kyc_status.id >= 4) {
            // setStatus("KYC_VERIFICATION_COMPLETED");
            setKycCheck(true);
            setCurrent(2);
          } else if (
            ProfData.kyc_status.id >= 3
            // || ProfData?.kyc_status?.description === "KYC Details completed, KYC verification pending"
          ) {
            setStatus("KYC_PENDING");
            setKycCheck(true);
            setCurrent(1);
            // setKycInfo('KYC verification pending.')
          } else if (ProfData.kyc_status.id >= 2) {
            setCurrent(1);
          }
        }
        dispatch(ONBDetils(ProfData));
        setloading(false);
      })
      .catch((err) => {
        console.log(err?.response);
        setloading(false);
        if (err?.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
      });
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ PAN_Number: e.target.value });
  };
  const handleAadhaarNumberChange = (e) => {
    const inputValue = e.target.value.replace(/\s/g, "").replace(/\D/g, "");
    const truncatedValue = inputValue.slice(0, 12);
    const formattedValue = truncatedValue.replace(/^[01]/, "");
    const finalValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1 ");
    e.target.value = finalValue;
    form.setFieldsValue({ aadhaar_number: finalValue });
  };
  // const AadharProps = {
  //   multiple: false,
  //   accept: "application/pdf, .jpg, .png",
  //   beforeUpload: (file) => {
  //     if (file.type.startsWith("image/")) {
  //       // Compress image files
  //       new Compressor(file, {
  //         quality: 0.6, // Adjust the quality as needed (0 to 1)
  //         success: (compressedFile) => {
  //           // Update the file list with the compressed file
  //           setAadharfileList([...AadharfileList, compressedFile]);
  //         },
  //         error: (err) => {
  //           console.error("Compression Error:", err.message);
  //           // In case of error, add the original file
  //           setAadharfileList([...AadharfileList, file]);
  //         },
  //       });
  //     } else {
  //       // Add non-image files directly
  //       setAadharfileList([...AadharfileList, file]);
  //     }
  //     // Prevent the default upload behavior
  //     return false;
  //   },
  //   onRemove: (file) => {
  //     const index = AadharfileList.indexOf(file);
  //     const newFileList = AadharfileList.slice();
  //     newFileList.splice(index, 1);
  //     setAadharfileList(newFileList);
  //   },
  //   fileList: AadharfileList,
  // };
  const AadharProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setAadharfileList([...AadharfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = AadharfileList.indexOf(file);
      const newFileList = AadharfileList.slice();
      newFileList.splice(index, 1);
      setAadharfileList(newFileList);
    },
    AadharfileList,
  };
  const PanProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setPanfileList([...PanfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = PanfileList.indexOf(file);
      const newFileList = PanfileList.slice();
      newFileList.splice(index, 1);
      setPanfileList(newFileList);
    },
    PanfileList,
  };
  const EduProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setEdufileList([...EdufileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = EdufileList.indexOf(file);
      const newFileList = EdufileList.slice();
      newFileList.splice(index, 1);
      setEdufileList(newFileList);
    },
    EdufileList,
  };
  const PassbookProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setPassfileList([...PassfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = PassfileList.indexOf(file);
      const newFileList = PassfileList.slice();
      newFileList.splice(index, 1);
      setPassfileList(newFileList);
    },
    PassfileList,
  };
  const props1 = {
    multiple: false,
    accept: ".jpg, .png",
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    EdufileList,
  };

  const next = (value) => {
    setloading(true);
    console.log(fileList[0]);
    console.log("next value", value);
    let post = {
      pan_card: value?.PAN_Number,
      Aadhar_number: value?.aadhaar_number,
      account_number: value?.accountNumber,
      ifsc_code: value?.ifscCode,
    };
    const formData = new FormData();

    Object.keys(post).forEach((key) => {
      formData.append(key, post[key]);
    });
    formData.append("Aadhar_copy", AadharfileList[0]);
    formData.append("pan_card_copy", PanfileList[0]);
    formData.append("selfie_photo", fileList[0]);
    formData.append("Education_Details", EdufileList[0]);
    formData.append("account_passbook", PassfileList[0]);
    axiosInPosp
      .post(`v1/posp/kyc_verification`, formData)
      .then((res) => {
        console.log(res);
        fetchData();
        setloading(false);
        // setCurrent(current + 1);
      })
      .then((err) => {
        console.log(err);
        setloading(false);
      });
  };
  const onFinish = (values) => {
    console.log(travelnum);
    console.log(values);
    message.success("Processing complete!");
  };
  // console.log("profData", profData);
  const steps = [
    {
      title: (
        <>Registration {current === 0 ? "Details" : <span>Completed</span>}</>
      ),
      content: (
        <>
          <ONBProfileEdit current={current} setCurrent={setCurrent} />
        </>
      ),
    },
    {
      title: (
        <>
          Bank{" "}
          {profData?.kyc_status?.description ===
          "Profile details completed, KYC details pending" ? (
            "Details"
          ) : profData?.kyc_status?.description ===
            "KYC Details completed, KYC verification pending" ? (
            <span style={{ color: "orange" }}>Processing</span>
          ) : profData?.kyc_status?.description ===
            "KYC verification completed, Training Pending" ? (
            <span>Completed</span>
          ) : profData?.kyc_status?.description ===
            "Training completed, Qualification Pending" ? (
            <span>Completed</span>
          ) : profData?.kyc_status?.description === "Qualified" ? (
            <span>Completed</span>
          ) : null}
        </>
      ),
      content: (
        <>
          {KycCheck ? (
            <>
              <Result
                status="success"
                title="KYC Documents"
                subTitle={
                  Status === "KYC_PENDING"
                    ? `Uploaded Successfully Waiting for Approval`
                    : `Kyc Verified`
                }
              />
              {profData?.kyc_status?.description ===
              "KYC Details completed, KYC verification pending" ? (
                <p className="chck-text">
                  Check Status{" "}
                  <span className="chck-icn">
                    <ReloadOutlined onClick={() => fetchData()} />
                  </span>
                </p>
              ) : null}
              <Row gutter={24} className="justify-content-center">
                {current > 0 && (
                  <Col span={6}>
                    <Form.Item className="step-btn-nxt">
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={() => setCurrent(current - 1)}
                      >
                        Back
                      </Button>
                    </Form.Item>
                  </Col>
                )}
                <Col span={6}>
                  <Form.Item className="step-btn-nxt">
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={() => setCurrent(current + 1)}
                      disabled={Status === "KYC_PENDING"}
                    >
                      Next
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Spin spinning={loading}>
                <h3>Enter Your Details</h3>
                <div className="step-container">
                  <Form
                    form={form}
                    layout="vertical"
                    //className='mx-auto'
                    requiredMark={false}
                    initialValues={{ field2: "" }}
                    onFinish={next}
                  >
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          //   {...formItemLayout}
                          initialValue={OTPData?.pan_card}
                          name="PAN_Number"
                          label="PAN Number"
                          rules={[
                            {
                              pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i,
                              message: "Invalid PAN Number",
                            },
                            { required: true, message: "Enter PAN Number" },
                          ]}
                        >
                          <Input
                            style={{ padding: "2px 10px" }}
                            onChange={handleInputChange}
                            placeholder="Enter PAN Number"
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          initialValue={OTPData?.aadhaar_number}
                          name="aadhaar_number"
                          label="Aadhaar Number"
                          rules={[
                            {
                              required: true,
                              message: "Enter Aadhaar Number",
                            },
                            {
                              pattern:
                                /^(?!0|1)\d{4}(?!0|1)\s?\d{4}(?!0|1)\s?\d{4}$/,
                              message: "Invalid Aadhaar Number",
                            },
                          ]}
                        >
                          <Input
                            style={{ padding: "2px 10px" }}
                            onChange={handleAadhaarNumberChange}
                            placeholder="Enter Aadhaar Number"
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          //initialValue={OTPData?.pan_card}
                          name="accountNumber"
                          label="Account Number"
                          rules={[
                            {
                              pattern: /^[0-9]+$/,
                              message: "Invalid A/C Number",
                            },
                            { required: true, message: "Enter A/C Number" },
                          ]}
                        >
                          <Input
                            maxLength={16}
                            style={{ padding: "2px 10px" }}
                            placeholder="Enter A/C Number"
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          //initialValue={OTPData?.pan_card}
                          name="ifscCode"
                          label="IFSC"
                          rules={[
                            // {
                            //   pattern: /^[0-9]+$/,
                            //   message: "Invalid IFSC Number",
                            // },
                            { required: true, message: "Enter ifsc Number" },
                          ]}
                        >
                          <Input
                            //maxLength={16}
                            style={{ padding: "2px 10px" }}
                            placeholder="Enter IFSC Number"
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ textAlign: "left" }}
                          name="aadhaar_copy"
                          label="Aadhaar Card"
                          rules={[
                            {
                              required: true,
                              message: "Please Upload Aadhaar Copy",
                            },
                          ]}
                        >
                          <Upload {...AadharProps} maxCount={1}>
                            <Button
                              type="primary"
                              className="upload-kyc-btn"
                              icon={<PlusOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          style={{ textAlign: "left" }}
                          name="education_copy"
                          label="Education (10th or 12th)"
                          rules={[
                            { required: true, message: "Please Upload " },
                          ]}
                        >
                          <Upload {...EduProps} maxCount={1}>
                            <Button
                              type="primary"
                              className="upload-kyc-btn"
                              icon={<PlusOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Form.Item
                          style={{ textAlign: "left" }}
                          name="pancard_copy"
                          label="Pan Card"
                          rules={[
                            {
                              required: true,
                              message: "Please Upload Pancard Copy",
                            },
                          ]}
                        >
                          <Upload {...PanProps} maxCount={1}>
                            <Button
                              type="primary"
                              className="upload-kyc-btn"
                              icon={<PlusOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          style={{ textAlign: "left" }}
                          label="Recent Selfie Photo"
                          name="pd_image"
                          rules={[
                            {
                              required: true,
                              message: "Please Upload your Image",
                            },
                          ]}
                        >
                          <Upload
                            className="parent"
                            {...props1}
                            maxCount={1}
                            listType="picture"
                            //onChange={onChange}
                          >
                            <Button
                              type="primary"
                              className="upload-kyc-btn"
                              icon={<PlusOutlined />}
                            >
                              Upload Photo
                            </Button>
                            {/* <p className='ant-upload-drag-icon'>
                            <UploadOutlined />
                            </p>
                            <p className='ant-upload-text'>Choose File</p> */}
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          style={{ textAlign: "left" }}
                          name="Account_passbook"
                          label="Account Passbook / Cheque Leaf"
                          rules={[
                            {
                              required: true,
                              message:
                                "Please Upload Account Passbook or Cheque Leaf",
                            },
                          ]}
                        >
                          <Upload {...PassbookProps} maxCount={1}>
                            <Button
                              type="primary"
                              className="upload-kyc-btn"
                              icon={<PlusOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24} className="justify-content-center">
                      {current > 0 && (
                        <Col span={6}>
                          <Form.Item className="step-btn-nxt">
                            <Button
                              type="primary"
                              htmlType="submit"
                              onClick={() => setCurrent(current - 1)}
                            >
                              Back
                            </Button>
                          </Form.Item>
                        </Col>
                      )}
                      <Col span={6}>
                        <Form.Item className="step-btn-nxt">
                          <Button type="primary" htmlType="submit">
                            Next
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Spin>
            </>
          )}
        </>
      ),
    },
    {
      title: (
        <>
          Learning{" "}
          {current === 2 ? (
            "Materials"
          ) : profData?.kyc_status?.id >= 5 ? (
            <span>Completed</span>
          ) : null}
        </>
      ),
      content: (
        <>
          <h3>Training E-Materials</h3>
          <div className="step-container">
            <div className="col-xl-9 col-lg-9 col-sm-12 mx-auto">
              <div
                style={{ background: "#eff5fa" }}
                className="w-100 d-flex align-items-center justify-content-center border-bottom p-2"
              >
                <div className="w-50 tr-text">Training Document</div>
                <div className="w-50 text-end pr-txt-end d-flex justify-content-end">
                  <a onClick={onDocClick} className="col-sm-12 col-md-5 tr-pdf">
                    <span>
                      <FilePdfOutlined />
                    </span>{" "}
                    Guidance
                  </a>
                  {showCount && <p className=" mb-0">{formattedTime}</p>}
                </div>
              </div>
              {/* {showCount && (
                <p className="text-center text-danger">
                  You can only access questions after
                  <span className="pr-txt-end">{formattedTime}</span>
                </p>
              )} */}
            </div>
          </div>
          <Row gutter={24} className="justify-content-center">
            {current > 1 && (
              <Col span={6}>
                <Form.Item className="step-btn-nxt">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setCurrent(current - 1)}
                  >
                    Back
                  </Button>
                </Form.Item>
              </Col>
            )}
            {Status === "TRAINING_COMPLETED" ? (
              <Col span={6}>
                <Form.Item className="step-btn-nxt">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setCurrent(current + 1)}
                    // disabled={showNext === false}
                  >
                    Next
                  </Button>
                </Form.Item>
              </Col>
            ) : null}
          </Row>
        </>
      ),
    },
    {
      title: (
        <>
          Examination{" "}
          {profData?.kyc_status?.id >= 6 ? <span>Completed</span> : null}
        </>
      ),
      content: (
        <>
          <h3>Questions</h3>
          <TrainingQuestion
            current={current}
            setCurrent={setCurrent}
            setSelectedContent={setSelectedContent}
          />
        </>
      ),
    },
  ];

  return (
    <>
      {/* <NavbarJourney /> */}
      <section
        className="bg-white"
        style={{ padding: 20 }}
        // style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 onb-step-outer">
              <p>Kyc Verification</p>
              <Steps
                className="onb-step"
                direction="vertical"
                current={current}
              >
                {steps?.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
                {/* {steps.map(item => (
                        <Steps.Item key={item.title} title={item.title} />
                    ))} */}
              </Steps>
            </div>
            <div className="text-center steps-content-onb col-xl-9 col-lg-9">
              {steps[current].content}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OnboardStep;
